"use client";
import { Size } from "@/api/AppApi/common-interfaces/api-enums";
import { useInViewEffect } from "react-hook-inview";
import { useState } from "react";
import { ITheme } from "@/api/AppApi/services/company/interfaces/ICompany";
import { getProductBoxDefaultDimAndSpacing } from "../../common/functions";
import useSellingMode from "@/hooks/useSellingMode";
import EnableSellingTooltip from "./EnableSellingTooltip";

interface Props {
  size: Size;
  scrollableTabs: boolean;
  theme: ITheme;
  children: any;
  isGrid: boolean;
}

const ProductCard: React.FC<Props> = ({
  size,
  scrollableTabs,
  children,
  isGrid,
}) => {
  const [isVisible, setIsVisible] = useState(false);
  const { enableAddToCart } = useSellingMode();
  const ref = useInViewEffect(
    ([entry], observer) => {
      if (entry.isIntersecting) {
        observer.unobserve(entry.target);
      }
      setIsVisible(entry.isIntersecting);
    },
    { threshold: 0 },
  );
  const smallBox = isSmallProductBox(size);
  const classname = smallBox
    ? `new-product-box-small${
        scrollableTabs && isGrid ? "-scrollable-tabs-grid" : ""
      }`
    : `new-product-box-large${
        scrollableTabs && isGrid ? "-scrollable-tabs-grid" : ""
      }`;
  return (
    <div ref={ref} className={classname}>
      {isVisible ? (
        <EnableSellingTooltip enableSelling={enableAddToCart}>
          {children}
        </EnableSellingTooltip>
      ) : (
        <div
          className={`skeleton-rect${scrollableTabs ? "-hor-product-box" : ""}`}
          style={{
            width: "100%",
            paddingTop: `${`max(${
              getProductBoxDefaultDimAndSpacing(size).height
            }px,100%`})`,
          }}
        ></div>
      )}
    </div>
  );
};

export default ProductCard;

const isSmallProductBox = (size: Size) =>
  [Size.small, Size.vertical_small].includes(size);
